import React from 'react'
import PropTypes from 'prop-types'
import TextTruncate from 'react-text-truncate'

import JobAttachmentsImages from './JobAttachmentsImages'

function JobAttachments({
  attachments, slug, status, type,
}) {
  const images = attachments.filter(attachment => ['png', 'jpg', 'jpeg'].includes(attachment.title.split('.').pop().toLowerCase()))
  const files = attachments.filter(attachment => !['png', 'jpg', 'jpeg'].includes(attachment.title.split('.').pop().toLowerCase()))

  function getLink() {
    if (status === 'available' && type === 'public') {
      return `3d-modeling-jobs/browse/${slug}/apply`
    }
    return `/profile/projects/${slug}`
  }

  return (
    <div className="jobs-attachments">
      <div className="jobs-attachments__title u-mb10">Attached files ({attachments.length})</div>

      {images.length > 0 && (
        <JobAttachmentsImages
          imagesUrls={images.slice(0, 3).map(image => ({ src: image.url }))}
          attachments={images.slice(0, 3).map(image => [image])}
        />
      )}

      {files.length > 0 && (
        <div className="row jobs-attachments__files">
          {files.slice(0, 3).map(file => (
            <div className="col-4" key={file.title}>
              <a href={file.url} target="_blank" className="text-default">
                <TextTruncate
                  text={file.title}
                  truncateText="(…)."
                  textTruncateChild={<span>{file.title.split('.').pop().toLowerCase()}</span>}
                  line={1}
                />
              </a>
            </div>
          ))}
        </div>
      )}

      {(images.length > 3 || files.length > 3) && (
        <div className="attachments__older-link">
          <a href={getLink()} className="text-semibold text-undecorated">see older attachments</a>
        </div>
      )}
    </div>
  )
}

JobAttachments.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
  slug: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}

export default JobAttachments
